import Book from "@mui/icons-material/Book";
import ChatBubble from "@mui/icons-material/ChatBubble";
import FolderCopy from "@mui/icons-material/FolderCopy";
import Settings from "@mui/icons-material/Settings";
import Timeline from "@mui/icons-material/Timeline";
import Chip from "@mui/material/Chip";
import PageContainer from "../components/Common/PageContainer";
import DashboardLayout from "../components/DashboardLayout/DashboardLayout";
import FeatureCards from "../components/FeatureCards";
import useSession from "../components/useSession/useSession";

export function Home() {
  const session = useSession();
  let features = [];
  if ((session?.OrionUserGroups ?? []).length > 0) {
    features.push({
      title: "Consulter mes dossiers",
      path: "/orion/assets",
      icon: <FolderCopy sx={{ fontSize: 40 }} />,
    });
  }
  if ((session?.OrionContributorGroups ?? []).length > 0) {
    features.push(
      {
        title: "Consulter mes configurations",
        path: "/orion/configs",
        icon: <Settings sx={{ fontSize: 40 }} />,
      },
      {
        title: "Consulter mes flux",
        path: "/orion/workflows",
        icon: <Timeline sx={{ fontSize: 40 }} />,
        children: (
          <Chip
            label="Coming Soon"
            color="secondary"
            size="small"
            sx={{ mt: 1 }}
          />
        ),
      }
    );
  }
  if ((session?.SiriusUserGroups?.length ?? 0) > 0) {
    features.push(
      {
        title: "Discuter avec mes agents",
        path: "/sirius/bots",
        icon: <ChatBubble sx={{ fontSize: 40 }} />,
      },
      {
        title: "Ajouter de la documentation",
        path: "/sirius/connectors",
        icon: <Book sx={{ fontSize: 40 }} />,
        children: (
          <Chip
            label="Coming Soon"
            color="secondary"
            size="small"
            sx={{ mt: 1 }}
          />
        ),
      }
    );
  }

  return (
    <DashboardLayout>
      <PageContainer maxWidth={false} breadcrumbs={[]}>
        <h1>Bonjour {session?.user.first_name} 👋</h1>
        <h4>
          <i>Bienvenue sur votre espace Reemia AI</i>
        </h4>

        <h3 className="pt-5 pb-3">Qu'avez vous envie de faire aujourd'hui ?</h3>
        <FeatureCards features={features} />
      </PageContainer>
    </DashboardLayout>
  );
}
